import React, { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import { DgaFooter, DgaIcon, DgaLink, DgaLoading } from "platformscode-new-react";
import Feedback from "../shared/Feedback";
import Rating from "../shared/Rating";
import { getConfig } from '../../services/api';
import './footer.css'
import FooterElement from "./FooterElement";


const injectCustomStyles = () => {
  setTimeout(() => {
    const shadowHost = document.querySelector("dga-footer");
    if (shadowHost && shadowHost.shadowRoot) {
      const allIconsContainers = shadowHost.shadowRoot.querySelectorAll(".icons-container");
      const allLinkLabels = shadowHost.shadowRoot.querySelectorAll(".link__label");

      // Inject static styles
      allIconsContainers.forEach((element) => {
        element.style.setProperty("display", "flex", "important");
        element.style.setProperty("margin-bottom", "32px", "important");
      });

      allLinkLabels.forEach((element) => {
        element.style.setProperty("font-size", "14px", "important");
        element.style.setProperty("line-height", "20px", "important");
        element.style.setProperty("font-weight", "400", "important");
      });

      // Inject <style> tag for hover effect
      const style = document.createElement("style");
      style.textContent = `
        .link__label:hover {
          opacity: 0.8 !important;
          text-decoration: underline !important;
        }
      `;

      const hgiStrokeElements = shadowHost.shadowRoot.querySelectorAll(".hgi-instagram");

      hgiStrokeElements.forEach((element) => {
        element.style.setProperty("padding", "80px", "important");
      });

      // Avoid injecting multiple times
      const existingStyle = shadowHost.shadowRoot.querySelector('style[data-injected="true"]');
      if (!existingStyle) {
        style.setAttribute('data-injected', 'true');
        shadowHost.shadowRoot.appendChild(style);
      }
    }
  }, 100); // Delay of 100ms
};

function Footer({
  zoomIn,
  zoomOut,
  toggleViewMode,
  toggleSpeech,
  zoomLevel,
  isViewGreyscale,
  isSpeechEnabled
}) {
  const location = useLocation();
  const [footerData, setFooterData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // دالة لتحديد نوع الصفحة
  const getPageType = () => {
    const pathname = location.pathname;

    // الصفحة الرئيسية
    if (pathname === '/' || pathname === '') {
      return 'home';
    }

    // صفحات الخدمات
    if (pathname.includes('/service-details')) {
      return 'service';
    }

    // باقي الصفحات
    return 'other';
  };

  const pageType = getPageType();

  // تحديد ما يجب إظهاره
  // التعديل هنا:
  const shouldShowRating = pageType === 'service'; // يظهر التقييم في صفحات الخدمات
  const shouldShowFeedback = pageType === 'service' || pageType === 'other'; // يظهر التغذية الراجعة في صفحات الخدمات و"باقي الصفحات"

  useEffect(() => {
    const fetchFooterData = async () => {
      try {
        setLoading(true);
        const data = await getConfig();
        setFooterData(data.data);
      } catch (err) {
        console.error('خطأ في جلب بيانات التذييل:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchFooterData();
  }, []);

  useEffect(() => {
    injectCustomStyles();
  }, [footerData]);

  useEffect(() => {
    const element = document.querySelector("icons-container");
    if (element) {
      element.classList.add("flex");
    }
  }, []);

  useEffect(() => {
    const dgaNavHeaderLogosElement = document.querySelector('dga-nav-header-logos');
    if (dgaNavHeaderLogosElement && dgaNavHeaderLogosElement.shadowRoot) {
      const style = document.createElement('style');
      style.textContent = `
              .header__logo img {
                  width: 192px !important;
                  height: auto !important;
              }
          `;
      dgaNavHeaderLogosElement.shadowRoot.appendChild(style);
    }
  }, []);


  if (loading) {
    return <div className="footer-loading flex items-center justify-center min-h-[200px]">
      <DgaLoading size="lg" variant="brand" />
    </div>;
  }

  if (error) {
    console.error("خطأ في تحميل بيانات التذييل:", error);
  }

  // استخراج البيانات من API أو استخدام القيم الافتراضية
  const groupLinksFromAPI = footerData?.footer?.groupLinks?.sections;
  const socialMediaLinksFromAPI = footerData?.footer?.socialLinks;
  const accessibilityLinksFromAPI = footerData?.footer?.accessTools;
  const copyrightFromAPI = footerData?.site?.copyright || "جميع الحقوق محفوظة لأمانة العاصمة المقدسة © 2025";
  const lastUpdateFromAPI = footerData?.site?.lastUpdate || "تاريخ آخر تعديل: 000000 م بتوقيت السعودية";
  const basicLinksFromAPI = footerData?.footer?.basicLinks;
  const extraLinksFromAPI = footerData?.footer?.extraLinks || [
    {
      name: "تم تطويره وصيانته بواسطة الوكالة المساعدة للتحول الرقمي",
      target: "#",
    },
    {
      name: "تاريخ آخر xx: 02/02/2026",
      target: "#",
    },
  ];
  const bottomImagesFromAPI = footerData?.footer?.bottomImages || [];
  const socialMediaTitleFromAPI = footerData?.footer?.groupLinks?.socialMediaTitle || "تابعنا على";
  const accessibilityTitleFromAPI = footerData?.footer?.groupLinks?.accessibilityTitle || "أدوات الاتاحة والوصول";
  const feedbackOptions = footerData?.footer?.feedback || null;

  return (
    <>
      {/* قسم آخر تحديث */}
      <div className="cw-full">
        <div>
          <section
            key="lastModifiedService"
            className="!items-center !gap-2 !self-stretch up-footer  c-ontent "
          >
            <p className=" cw-full !m-0">{lastUpdateFromAPI}</p>
          </section>
        </div>
      </div>

      {/* التقييم والتغذية الراجعة - حسب نوع الصفحة */}
      {shouldShowRating && <Rating />}
      {shouldShowFeedback && <Feedback feedbackOptions={feedbackOptions} />}

      {/* مكون الفوتر الجديد */}
      <FooterElement
        footerData={footerData}
        groupLinks={groupLinksFromAPI}
        socialMediaLinks={socialMediaLinksFromAPI}
        accessibilityLinks={accessibilityLinksFromAPI}
        copyright={copyrightFromAPI}
        lastUpdate={lastUpdateFromAPI}
        basicLinks={basicLinksFromAPI}
        extraLinks={extraLinksFromAPI}
        bottomImages={bottomImagesFromAPI}
        socialMediaTitle={socialMediaTitleFromAPI}
        accessibilityTitle={accessibilityTitleFromAPI}
        // دوال الإتاحة من الهيدر
        zoomIn={zoomIn}
        zoomOut={zoomOut}
        toggleViewMode={toggleViewMode}
        toggleSpeech={toggleSpeech}
        zoomLevel={zoomLevel}
        isViewGreyscale={isViewGreyscale}
        isSpeechEnabled={isSpeechEnabled}
      />
    </>
  );
}

export default Footer;
